import Component, { ComponentLoader } from '@bythepixel/component-loader';
import VehicleComparisonController from '@Core/controllers/vehicleComparisonController';
import VehicleCard from '@Core/components/vehicleCard';
import InViewSrc from '@Core/components/inViewSrc';
import InViewSrcset from '@Core/components/inViewSrcset';
import { reloadScripts } from '@Core/utility';

const DEFAULTS = {
  componentsToReload: [InViewSrc, InViewSrcset, VehicleCard],
};

class FavoritesController extends Component {
  static selector = '[data-comp-favorites-controller]';
  static footerSelector = '[data-comp-navigationfooter]';
  static favoriteCtaSelector = '[data-comp-favorites-header-cta]';

  static ctaHiddenClass = 'favorites-page__header-cta--hidden';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.componentsToReload = options.componentsToReload || [];

    this.mount();
  }

  attachListeners() {
    window.addEventListener('livewire:pagination-clicked', () => {
      window.scrollTo(0, 0);
    });

    window.addEventListener('livewire:page-updated', () => {
      setTimeout(() => {
        reloadScripts(document, this.componentsToReload);
      }, 100);
    });

    this.toggleCTAFooter();

    return this;
  }

  toggleCTAFooter() {
    const footer = document.querySelector(FavoritesController.footerSelector);
    const favoriteCta = document.querySelector(
      FavoritesController.favoriteCtaSelector,
    );

    if (!footer || !favoriteCta) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        favoriteCta.classList.toggle(
          FavoritesController.ctaHiddenClass,
          entry.isIntersecting,
        );
      });
    });

    observer.observe(footer);
  }

  mount() {
    this.attachListeners();
  }
}

const loader = new ComponentLoader(document, [
  FavoritesController,
  VehicleComparisonController,
]);
